import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ServiceTypeTab } from "@/types/filter";
import { userLoggedOut } from "../auth/authSlice";

type SetCurrentServiceTabPayload = {
  tab: ServiceTypeTab | undefined;
};

export type ServiceTabState = {
  currentServiceTab: ServiceTypeTab | undefined;
};

const initialState: ServiceTabState = {
  currentServiceTab: undefined,
};

const serviceTabSlice = createSlice({
  name: "serviceTab",
  initialState,
  reducers: {
    setCurrentServiceTab: (
      state,
      action: PayloadAction<SetCurrentServiceTabPayload>
    ) => {
      state.currentServiceTab = action.payload.tab;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLoggedOut, () => {
      return initialState;
    });
  },
});

export const { setCurrentServiceTab } = serviceTabSlice.actions;

export const selectCurrentServiceTab = (state: RootState) =>
  state.serviceTab.currentServiceTab;

export default serviceTabSlice.reducer;